import camelCase from "lodash/camelCase";
import isEmpty from "lodash/isEmpty";

import { createSchemaOption } from "Components/shared/RVEventSchemaOption/RVEventSchemaOption";

import { EventOptionType, EventSchemaOptionEntry, OptionsData } from "../eventSchemaTypes";

export function camelCaseToTitleCase(str: string) {
    const camelCaseFieldsButNotObject = (token: string, index: number) => (index === 0 ? camelCase(token) : token);
    const fieldName = str?.split(".")?.map(camelCaseFieldsButNotObject)?.join(".");
    return fieldName;
}

export function createOptionsWithPrefix(item: Record<string, string>, prefix?: string) {
    /*
        This function is used to create options with a prefix and camelCase the field name,
        which is called in the Journey for UpdateContact node (ingest expects to compare 
        the top-level field with camel case) and ai agent workspace for multi-state flow.
    */
    const fieldName = camelCaseToTitleCase(item.fieldName);
    return {
        value: `${prefix}.${fieldName}`,
        label: `${prefix}.${fieldName}`,
        dataType: item.fieldType,
    };
}

export function createOptionsWithPrefixWithOriginalFieldName(item: Record<string, string>, prefix?: string) {
    /*
        This function is used to create options with a prefix and keep the original field name,
        which is called in the Journey for Webhook node, conditional node, and Decision AI node.
        These are expected to be compared with original field name in ingest.
    */
    const fieldName = item.fieldName;
    return {
        value: `${prefix}.${fieldName}`,
        label: `${prefix}.${fieldName}`,
        dataType: item.fieldType,
    };
}
// The camelcase value indicates whether the field names should be converted to camel case or not
export function toNamespacedFieldLookup(
    fields: EventSchemaOptionEntry,
    namespace: string,
    camelCase: boolean = true
): Array<EventOptionType> {
    if (isEmpty(fields)) {
        return [];
    }
    const prefixFn = camelCase ? createOptionsWithPrefix : createOptionsWithPrefixWithOriginalFieldName;
    return (fields as any).map(([fieldName, type]: [string, { fieldType: string; fieldId: string }]) =>
        prefixFn(
            {
                fieldName,
                fieldType: type.fieldType,
            },
            namespace
        )
    );
}

export function toContactsFieldLookup(
    contactAttributes: EventSchemaOptionEntry,
    camelCase: boolean = true
): Array<EventOptionType> {
    return toNamespacedFieldLookup(contactAttributes, "contact", camelCase);
}

export function flattenSchemaOptions(
    eventSchema: EventSchemaOptionEntry | undefined,
    highlightVal: string,
    hideTypeLabel: boolean,
    useFieldId: boolean = false
): OptionsData {
    const schemaKeys: OptionsData = [];

    if (!eventSchema) {
        return [];
    }

    Object.entries(eventSchema).forEach(([key, val]) =>
        schemaKeys.push(
            createSchemaOption(key, useFieldId ? val.fieldId : key, val.fieldType, highlightVal, hideTypeLabel)
        )
    );
    return schemaKeys.sort((a, b) =>
        a.value.toLowerCase() > b.value.toLowerCase() ? 1 : b.value.toLowerCase() > a.value.toLowerCase() ? -1 : 0
    );
}
